module.exports = __webpack_public_path__ + "images/backgrounds/reach-stars-8ed7b568520cfddf6aa41d0302748c77.svg";